import React from "react";
import {
  Box,
  Stack,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

// 子供コンポーネント
import {
  AnswerItemOne,
  AnswerItemTwo,
  AnswerItemThree,
} from "./answerTypeItems";

import { closeKeyboard } from "../../../utils/closeKeyboard";

// 質問種別１
export const QuestionItemOne = ({
  answerYesNo,
  questionnaireItems,
  itemAnswers = [],
  setItemAnswers,
}) => {
  return (
    <RadioGroup
      sx={{ marginLeft: "22%" }}
      onChange={(e) => setItemAnswers([{ itemNo: e.target.value }])}
    >
      {questionnaireItems.map((item, index) => {
        if (item.itemTextAnswerType === "1") {
          return (
            <FormControlLabel
              key={index}
              value={item.itemNo}
              control={<Radio />}
              checked={
                !!itemAnswers.find(
                  (i) => i.itemNo?.toString() === item.itemNo?.toString()
                )
              }
              disabled={!answerYesNo}
              label={item.itemTitle}
            />
          );
        } else if (item.itemTextAnswerType === "3") {
          return (
            <Box key={index}>
              <FormControlLabel
                value={item.itemNo}
                control={<Radio />}
                checked={
                  !!itemAnswers.find(
                    (i) => i.itemNo?.toString() === item.itemNo?.toString()
                  )
                }
                disabled={!answerYesNo}
                label={item.itemTitle}
              />
              <TextField
                variant="outlined"
                size="small"
                disabled={!answerYesNo}
                onChange={(event) => {
                  setItemAnswers([
                    { itemNo: item.itemNo, itemAnswerText: event.target.value },
                  ]);
                }}
                onKeyDown={(event) => closeKeyboard(event)}
                value={
                  itemAnswers.find(
                    (i) => i.itemNo?.toString() === item.itemNo?.toString()
                  )?.itemAnswerText || ""
                }
              />
            </Box>
          );
        } else {
          return <></>;
        }
      })}
    </RadioGroup>
  );
};

// 質問種別2と3
export const QuestionItemTwoAndThree = ({
  answerYesNo,
  questionnaireItems,
  itemAnswers,
  setItemAnswers,
}) => {
  return (
    <Stack sx={{ marginLeft: "22%" }}>
      {questionnaireItems.map((item, index) => {
        if (item.itemTextAnswerType === "1") {
          return (
            <AnswerItemOne
              key={index}
              answerYesNo={answerYesNo}
              item={item}
              itemAnswers={itemAnswers}
              setItemAnswers={setItemAnswers}
            />
          );
        } else if (item.itemTextAnswerType === "2") {
          return (
            <AnswerItemTwo
              key={index}
              answerYesNo={answerYesNo}
              item={item}
              itemAnswers={itemAnswers}
              setItemAnswers={setItemAnswers}
            />
          );
        } else if (item.itemTextAnswerType === "3") {
          return (
            <AnswerItemThree
              key={index}
              answerYesNo={answerYesNo}
              item={item}
              itemAnswers={itemAnswers}
              setItemAnswers={setItemAnswers}
            />
          );
        } else {
          return <></>;
        }
      })}
    </Stack>
  );
};
